import React from "react";
import { SearchParameters } from "../../model/SearchParameters";

interface SortOptionsProps {
  searchParams: SearchParameters;
  setSearchParams: React.Dispatch<React.SetStateAction<SearchParameters>>;
}

const SortOptions: React.FC<SortOptionsProps> = ({
  searchParams,
  setSearchParams,
}) => {
  const handleSortChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSearchParams((prevParams) => ({
      ...prevParams,
      sort: event.target.value,
      page: 1, // Reset to the first page when the sort option changes
    }));
  };

  return (
    <li>
      <select
        defaultValue={searchParams?.sort}
        className="is-clickable button"
        onChange={handleSortChange}
      >
        {[
          { value: "name asc", label: "Nome A-Z" },
          { value: "name desc", label: "Nome Z-A" },
          {
            value: "configured_price_pvp_with_vat asc",
            label: "Preço Crescente",
          },
          {
            value: "configured_price_pvp_with_vat desc",
            label: "Preço Decrescente",
          },
        ].map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </li>
  );
};

export default SortOptions;
